// Only branding endpoints use envelope errors; legacy endpoints keep their existing contract.
export async function themeQuery(baseQuery, url, body) {
	const result = await baseQuery({ url, method: "post", body });
	if (result.error) return result;
	if (result.data?.error) {
		return { error: { status: result.data.statusCode || "CUSTOM_ERROR", data: result.data } };
	}
	if (!result.data?.data) {
		return { error: { status: "CUSTOM_ERROR", data: { message: "Invalid branding response" } } };
	}
	return result;
}
